module.exports = __webpack_public_path__ + "img/whatsapp-icon.8eaad951.png";